import type { RouteRecordRaw, Router } from 'vue-router'

const LawyerRoutes: RouteRecordRaw = {
  path: '/lawyer',
  name: 'LawyerModulePages',
  redirect: { name: '' },
  children: [
    {
      path: '',
      name: 'ManageLawyerRoute',
      component: () => import('./views/ManageLawyersView.vue'),
      meta: {
        title: 'lawyer.lawyers',
      },
    },
  ],
  meta: {
    layout: 'Default',
  },
}

export default (router: Router) => {
  router.addRoute(LawyerRoutes)
}
